import React, { useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

import { Button } from "components";

export const Title = styled.div`
  font-family: Noto Sans JP;
  font-size: 18px;
  font-weight: 700;
  line-height: 21.6px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2f8cae;
  margin-bottom: 24px;
`;

const Description = styled.div`
  font-family: Noto Sans JP;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #3b3b3b;
  margin-bottom: 32px;
`;

const GroupButton = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;

  button {
    width: 128px;
    height: 40px;
  }

  button:first-child {
    border-radius: 8px;
    border: 1px solid #cccccc;
  }
`;

const FIXED_SEARCH_PARAMS =
  "?name=南小国町&super-city-code=k_minamioguni_town&identity-code-title=登録番号&is-verify-identity-code=false";
const FIXED_SEARCH_PARAMS_ENCODED =
  "?name=%E5%8D%97%E5%B0%8F%E5%9B%BD%E7%94%BA&super-city-code=k_minamioguni_town&identity-code-title=%E7%99%BB%E9%8C%B2%E7%95%AA%E5%8F%B7&is-verify-identity-code=false";
const REPLACED_SEARCH_PARAMS =
  "?name=南小国町&super-city-code=k_minamioguni_town&identity-code-title=登録番号&is-verify-identity-code=true";

const NursingHomeRegistration: React.FC = () => {
  const { search } = useLocation();
  const superCityName = new URLSearchParams(search).get("name");
  const url = `/verify-phone-number${window.location.search}`;

  useEffect(() => {
    if (
      search === FIXED_SEARCH_PARAMS ||
      search === FIXED_SEARCH_PARAMS_ENCODED
    ) {
      window.location.replace(
        `/personalregistration/SII${REPLACED_SEARCH_PARAMS}`
      );
    }
  }, [search]);
  return (
    <div>
      <Title>{superCityName}</Title>
      <Description>{superCityName}の登録を行いますか？</Description>
      <GroupButton>
        <Button
          name="いいえ"
          background="#FFFFFF"
          color="#333333"
          border="none"
          fontSize={16}
          fontWeight={700}
          padding="5px 16px"
          onClick={() => {
            window.location.replace("https://www.leber.jp/");
          }}
        />
        <Button
          name="はい"
          background="#2F8CAE"
          color="#FFFFFF"
          border="none"
          fontSize={16}
          fontWeight={700}
          padding="5px 16px"
          onClick={() => {
            window.location.replace(url);
          }}
        />
      </GroupButton>
    </div>
  );
};

export default NursingHomeRegistration;
